import { Component } from '@angular/core';

import { AdminService } from '../services/admin.service';
import { NceAdminService } from '../../nce-admin/services/nce-admin.service';

import { LayoutService } from '../../shared/services/layout.service';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import {LazyLoadEvent} from 'primeng/components/common/api';
import {FilterMetadata} from 'primeng/components/common/api';

@Component({
	selector: 'admin-user-account',
	templateUrl: 'user-account.component.html'
})
export class AdminUserAccountComponent {    
    totalRecords: number;

    vPageSize: number = STATIC_VALUE.TABLE.PAGE_SIZE;

    vLoading: boolean = false;

    vEmail: string = '';
    vUserRole: number = 0;

    resettedTable: number = 0;

    vUserLists: Array<{
        user_record_id: number,
        email: string,
        create_date: string,
        description: string,
        company_name: string
    }>;

    vNCESearchBy: string = '';
    vNCEFilterBy: string = '';

    constructor(
        private _adminService: AdminService,
        private _layoutService: LayoutService,
        private _nceAdminService: NceAdminService,
	){}
	
    ngOnInit(){
        this._layoutService.setCurrentPage('admin-user-account');
        this.vLoading = true;
        this._adminService.loadTotalData(this.vEmail, this.vUserRole).then(
            (resolve) => {
                this._adminService.loadUsers(0, this.vPageSize, this.vEmail, this.vUserRole).then(
                    (resolve) => {
                        this.vLoading = false;
                        this.totalRecords = this._adminService.getTotalData();
                        this.vUserLists = this._adminService.getUsersList();
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
        this._adminService.loadAllUserRoles();
        this.vNCESearchBy = this.getSearchBy()[0].type;
    }

    getUserTypeList() {
		return this._adminService.getAllRoles();
    }

    getSearchBy() {
        let data = [];
        for(let nce of STATIC_VALUE.SEARCH_BY.adminUserAccount){
            if(nce.nceValue !== ''){
                data.push(nce);
            }
        }
		return data;
    }

    resetNCEFilter() {
        this.vNCEFilterBy = '';
    }

    filterNCE(){
        this.vLoading = true;
        this._adminService.loadTotalCompanyData(this.vNCESearchBy, this.vNCEFilterBy, this.vUserRole).then(
            (resolve) => {
                this._adminService.loadUsersFilterBy(0, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vUserRole).then(
                    (resolve) => {
                        this.vLoading = false; 
                        this.totalRecords = this._nceAdminService.getTotalData();
                        this.vUserLists = this._adminService.getUsersList();
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
    }

    filterUser(){
        this.vLoading = true;
        this.resettedTable = 0;
        this._adminService.loadTotalCompanyData(this.vNCESearchBy, this.vNCEFilterBy, this.vUserRole).then(
            (resolve) => {
                //this.totalRecords = this._nceAdminService.getTotalData();
                this._adminService.loadUsersFilterBy(0, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vUserRole).then(
                    (resolve) => {
                        this.vLoading = false; 
                        this.totalRecords = this._nceAdminService.getTotalData();
                        this.vUserLists = this._adminService.getUsersList();
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
        //Old search method
        // this._adminService.loadTotalData(this.vEmail, this.vUserRole).then(
        //     (resolve) => {
        //         this._adminService.loadUsers(0, this.vPageSize, this.vEmail, this.vUserRole).then(
        //             (resolve) => {
        //                 this.vLoading = false;
        //                 this.totalRecords = this._adminService.getTotalData();
        //                 this.vUserLists = this._adminService.getUsersList();
        //             },
        //             (reject) => {
        //                 this.vLoading = false;
        //             }
        //         );
        //     },
        //     (reject) => {
        //         this.vLoading = false;
        //     }
        // );
    }

    loadUsersLazy(event: LazyLoadEvent) {
        if(this.vLoading){
            return;
        }

        let vPageNumber = event.first/this.vPageSize;

        this.vLoading = true;
        this._adminService.loadUsers(vPageNumber, this.vPageSize, this.vEmail, this.vUserRole).then(
            (resolve) => {
                this.vLoading = false;
                this.vUserLists = this._adminService.getUsersList();
            },
            (reject) => {
                this.vLoading = false;
            }
        );
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/admin/components/user-account.component.ts